import { SectionTitle } from "../../components/common/SectionTitle";
import { galleryImages } from "../../data/siteData";

export function GallerySection() {
  return (
    <section id="gallery" className="site-section site-section--soft">
      <div className="container">
        <SectionTitle subtitle="Portfolio" title="Our Artistry" />

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <figure key={image} className="gallery-card scroll-reveal">
              <img src={image} alt={`Gallery style ${index + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
